import { useQuery } from '@apollo/client';
import { RecursiveNonNullable } from 'typescript/helpers';
import { Errors } from '../../Shared/Errors';
import {
  GetSubdomainDivisions,
  GetSubdomainDivisions_subDomain_departments,
  GetSubdomainDivisions_subDomain_locations,
} from '../__generated__/GetSubdomainDivisions';
import { SUBDOMAIN_DIVISIONS_QUERY } from '../withSubdomainDivisions';

export const useSubdomainDivisions = (subdomain: string) => {
  const { data, loading } = useQuery<GetSubdomainDivisions>(
    SUBDOMAIN_DIVISIONS_QUERY,
    {
      variables: { subdomain },
      skip: !subdomain,
    },
  );
  if (loading) {
    return {
      loading: true,
    };
  }

  if (data?.subDomain) {
    return {
      loading: false,
      locations:
        Array.isArray(data.subDomain) && data.subDomain[0]
          ? (data.subDomain[0].locations?.filter(
              location => location?.id && location?.name,
            ) as RecursiveNonNullable<GetSubdomainDivisions_subDomain_locations>[])
          : undefined,
      departments:
        Array.isArray(data.subDomain) && data.subDomain[0]
          ? (data.subDomain[0].departments?.filter(
              department => department?.id && department?.name,
            ) as RecursiveNonNullable<GetSubdomainDivisions_subDomain_departments>[])
          : undefined,
    };
  }

  return { loading: false, error: Errors.ServerError };
};

export default useSubdomainDivisions;
